"use client"

import PropTypes from "prop-types"
import { RiArrowRightCircleLine } from "react-icons/ri"

import { useLocaleConfig } from "@/providers"
import { useLocaleStrings } from "@/providers/localeStrings/client"
import theme from "@/theme"

import { Button } from "./Button"

/**
 * This component renders a button with icon and text that navigates to the documents page for a specific customer.
 *
 * @param {object} props
 * @param {string} props.customerNumber - The customer number
 * @param {string} props.text - The text of the button
 * @param {ReactNode} props.children - The icon of the button
 * @returns {JSX.Element}
 */
export const DocumentButton = ({ customerNumber, text, children, ...props }) => {
  const { normal } = theme.iconSizes
  const { DOCUMENTS_TITLE } = useLocaleStrings()
  const locale = useLocaleConfig().locale ?? "de-DE"

  if (!customerNumber) return null

  return (
    <Button
      href={`/${locale}/customers/${customerNumber}/documents`}
      style={{ alignSelf: "center" }}
      rounded
      {...props}
    >
      {children ?? <RiArrowRightCircleLine size={normal} />}
      {text ?? DOCUMENTS_TITLE}
    </Button>
  )
}

DocumentButton.propTypes = {
  /** Defines the customer number to link to the documents page */
  customerNumber: PropTypes.string.isRequired,
  /** Defines the text of the button */
  text: PropTypes.string,
  /** Defines the icon of the button */
  children: PropTypes.node,
}
